import { connect } from 'react-redux';
import React, { useEffect, useState } from "react";
import BlockHeader from "../../../../component/BlockHeader/BlockHeader";
import UserState from "../../../../store/stateMap";
import api from '../../../../api';
import { useSearchParams, useNavigate, Link, createSearchParams } from "react-router-dom";
import _ from "lodash";
import EditEvent from "../../../../component/EditEvent";
import {ReactComponent as SVGleft} from '../../../../assets/arrow-left-3.svg';

import "../../../../sass/form/form.scss";
import "./../style.scss";
import "./style.scss";
import LoginBox from 'component/LoginBox/LoginBox';

const PageCreateFormEvent = (props) => {
    

    let [searchParams]  = useSearchParams();
    
    let navigate        = useNavigate();

    const [initiative, setInitiative] = useState(false);

    const [formDataLoad, setFormDataLoad] = useState(true);


    useEffect(()=>{

        if(props.auth.user)
        {
            if(searchParams.get('id') > 0)
            {
                setFormDataLoad(true);
    
                Promise.all([
                    api('/Initiative', 'get', {
                        id : searchParams.get('id')            
                    }, 'Bearer ' + props.auth.token)
                ])
                    .then((response) => {
    
                        setInitiative(response[0].initiative[0]);
    
                        setFormDataLoad(false);
    
                    })
            }
            else
            {
                navigate({
                    pathname    : '/create'  
                });   
            }
        }

    }, [props.auth.user]);

    return (
        props.auth.user ?
        <div className="form-initiative-basic container w-800 relative">
            <span className="registration-back">
                {
                    !formDataLoad &&
                    <Link to={{
                        pathname : '/create/describe'
                        ,search : `?${createSearchParams({
                            id : initiative.InitiativeID
                        })}`
                    }}><SVGleft/> Back</Link>
                }
            </span>
            <div className="text-center">
                <span className="block text-xs mb-5">4 of 4</span>
                <BlockHeader title="Fine-Tune Your Initiative" desc="Complete all necessary info for your event initiative" />
            </div>

            {
                formDataLoad ? <span className="skeleton"></span> :
                <EditEvent sentInitiative={initiative} onSave={(editedInitiative) => {
                    navigate({
                        pathname    : '/initiative/' + editedInitiative.Slug  
                    });
                }}/>
            }



        </div> : 
        <LoginBox/>
    )
}

export default connect(UserState)(PageCreateFormEvent);